module.exports = __webpack_public_path__ + "static/media/nw.logo.553216a0.png";